import { ColSize, RowSize } from '../../../../../../shared/components';
import { SavedQuotesFilter, SavedQuotesTable } from '../';

export const SavedQuotesContainer = () => (
  <RowSize>
    <ColSize size={100}>
      <SavedQuotesFilter />
    </ColSize>

    <ColSize size={100}>
      <SavedQuotesTable />
    </ColSize>
  </RowSize>
);
